module.exports = __webpack_public_path__ + "static/media/dropdown_Arrow.cf36887f.svg";